import { createAction, props } from '@ngrx/store';

export const faqClicked = createAction(
  '[Content] faq clicked',
  props<{ question: string }>()
);
